<template>
  <div class="supplier-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <i class="el-icon-s-shop"></i> 供货商管理
          </el-breadcrumb-item>
          <el-breadcrumb-item>供货商列表</el-breadcrumb-item>
        </el-breadcrumb>
        
      </div>
      
    </div>

    <!-- 统计卡片 (支付宝风格常用指标) -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon icon-total">
          <i class="el-icon-office-building"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">总供货商</div>
          <div class="stat-number">{{ total }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-active">
          <i class="el-icon-check"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">正常</div>
          <div class="stat-number">{{ activeCount }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-inactive">
          <i class="el-icon-remove-outline"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">停用</div>
          <div class="stat-number">{{ inactiveCount }}</div>
        </div>
      </div>
    </div>

    <!-- 搜索和筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>

      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        ref="searchFormRef"
        class="filter-form"
      >
        <div class="filter-row">
          <el-form-item label="供货商名称">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入供货商名称"
              clearable
              prefix-icon="el-icon-office-building"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系人">
            <el-input
              v-model="searchForm.contact_name"
              placeholder="请输入联系人"
              clearable
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系电话">
            <el-input
              v-model="searchForm.contact_tel"
              placeholder="请输入联系电话"
              clearable
              prefix-icon="el-icon-phone"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              clearable
              style="width: 200px;"
            >
              <el-option label="正常" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="action-buttons">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchSubmit"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button
              icon="el-icon-refresh"
              @click="resetSearch"
              class="reset-btn"
            >
              重置
            </el-button>
             <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addData"
          class="add-btn"
        >
          新增供货商
        </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 数据表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">供货商列表</span>
          <el-tag type="info" size="small" effect="plain">共 {{ total }} 条记录</el-tag>
        </div>
        <div class="table-header-right">
          <el-tooltip content="刷新数据" placement="top">
            <el-button
              icon="el-icon-refresh"
              size="small"
              circle
              @click="getList"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导出数据" placement="top">
            <el-button
              icon="el-icon-download"
              size="small"
              circle
              @click="handleExport"
            ></el-button>
          </el-tooltip>
        </div>
      </div>

      <el-table
        :data="tableData"
        size="small"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            <span class="index-badge">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="供货商名称"
          min-width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="supplier-info">
              <i class="el-icon-office-building"></i>
              <span class="name-text">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="联系人"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="contact-info">
              <i class="el-icon-user"></i>
              <span>{{ scope.row.contact_name || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="联系电话"
          width="140"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="contact-phone">
              <i class="el-icon-phone"></i>
              <span>{{ scope.row.contact_tel || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="地址"
          min-width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="address-cell">
              <i class="el-icon-map-location"></i>
              <span class="address-text">{{ scope.row.address || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="备注"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="remark-text">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              size="small"
              effect="plain"
            >
              {{ scope.row.status === 1 ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="添加时间"
          width="160"
          sortable="custom"
          prop="add_time"
        >
          <template slot-scope="scope">
            <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="200"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="goEdit(scope.row)"
                class="edit-btn"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                class="delete-btn"
              >
                删除
              </el-button>
              
              <el-dropdown
                trigger="click"
                size="small"
                @command="(command) => handleCommand(command, scope.row)"
              >
                <span class="more-btn">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-view"
                    @click.native="goDetail(scope.row)"
                    command="detail"
                  >
                    查看详情
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status === 1"
                    icon="el-icon-remove"
                    command="disable"
                    divided
                  >
                    停用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-else
                    icon="el-icon-check"
                    command="enable"
                    divided
                  >
                    启用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
      class="alipay-dialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="100px"
        size="small"
        label-position="right"
      >
        <el-form-item label="供货商名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入供货商名称" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="联系人" prop="contact_name">
          <el-input v-model="form.contact_name" placeholder="请输入联系人" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="contact_tel">
          <el-input v-model="form.contact_tel" placeholder="请输入联系电话" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="地址" prop="address">
          <el-input
            v-model="form.address"
            type="textarea"
            :rows="2"
            placeholder="请输入详细地址"
            maxlength="1024"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="供货商详情"
      :visible.sync="detailVisible"
      width="520px"
      class="alipay-dialog"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="供货商名称">{{ detailData.name }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ detailData.contact_name || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detailData.contact_tel || '--' }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ detailData.address || '--' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailData.remark || '--' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detailData.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
            {{ detailData.status === 1 ? '正常' : '停用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="添加时间">{{ detailData.add_time | dateFormat }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

// Mock API - 实际使用时请替换为真实接口
const mockApi = {
  // 获取供货商列表
  getSupplierList(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        // 从 localStorage 读取数据，如果没有则初始化
        let suppliers = localStorage.getItem('supplier_mock_data')
        if (!suppliers) {
          const initData = [
            { id: 1, name: '宏达电子有限公司', company_id: 1, contact_name: '张明', contact_tel: '13800138001', remark: '长期合作供应商，提供优质电子元件', address: '深圳市南山区科技园', status: 1, is_del: 0, add_time: Math.floor(Date.now() / 1000) - 86400 * 30 },
            { id: 2, name: '宏远物流配送中心', company_id: 1, contact_name: '李芳', contact_tel: '13800138002', remark: '主要负责华南区配送，时效稳定', address: '广州市天河区黄埔大道', status: 1, is_del: 0, add_time: Math.floor(Date.now() / 1000) - 86400 * 15 },
            { id: 3, name: '宏达精密机械厂', company_id: 1, contact_name: '王强', contact_tel: '13800138003', remark: '提供精密零部件，质量可靠', address: '东莞市长安镇', status: 0, is_del: 0, add_time: Math.floor(Date.now() / 1000) - 86400 * 7 },
            { id: 4, name: '宏达包装材料有限公司', company_id: 1, contact_name: '陈丽', contact_tel: '13800138004', remark: '包装箱定制，环保材料', address: '佛山市顺德区', status: 1, is_del: 0, add_time: Math.floor(Date.now() / 1000) - 86400 * 3 },
          ]
          localStorage.setItem('supplier_mock_data', JSON.stringify(initData))
          suppliers = initData
        } else {
          suppliers = JSON.parse(suppliers)
        }
        
        // 过滤未删除的数据
        let list = suppliers.filter(item => item.is_del === 0 && item.company_id === (params.company_id || 1))
        
        // 搜索过滤
        if (params.name) {
          list = list.filter(item => item.name.includes(params.name))
        }
        if (params.contact_name) {
          list = list.filter(item => item.contact_name && item.contact_name.includes(params.contact_name))
        }
        if (params.contact_tel) {
          list = list.filter(item => item.contact_tel && item.contact_tel.includes(params.contact_tel))
        }
        if (params.status !== '' && params.status !== undefined && params.status !== null) {
          list = list.filter(item => item.status === params.status)
        }
        
        // 排序处理
        if (params.sortField && params.sortOrder) {
          list.sort((a, b) => {
            const aVal = a[params.sortField] || 0
            const bVal = b[params.sortField] || 0
            if (params.sortOrder === 'ascending') {
              return aVal - bVal
            } else {
              return bVal - aVal
            }
          })
        }
        
        const total = list.length
        const start = (params.pageNum - 1) * params.pageSize
        const data = list.slice(start, start + params.pageSize)
        
        resolve({ code: 200, data: data, total: total, msg: 'success' })
      }, 300)
    })
  },
  
  // 新增供货商
  addSupplier(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let suppliers = localStorage.getItem('supplier_mock_data')
        suppliers = suppliers ? JSON.parse(suppliers) : []
        const newId = suppliers.length > 0 ? Math.max(...suppliers.map(s => s.id)) + 1 : 1
        const newSupplier = {
          ...data,
          id: newId,
          is_del: 0,
          add_time: Math.floor(Date.now() / 1000)
        }
        suppliers.push(newSupplier)
        localStorage.setItem('supplier_mock_data', JSON.stringify(suppliers))
        resolve({ code: 200, msg: '添加成功', data: newSupplier })
      }, 300)
    })
  },
  
  // 更新供货商
  updateSupplier(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let suppliers = localStorage.getItem('supplier_mock_data')
        suppliers = suppliers ? JSON.parse(suppliers) : []
        const index = suppliers.findIndex(s => s.id === data.id)
        if (index !== -1) {
          suppliers[index] = { ...suppliers[index], ...data, add_time: suppliers[index].add_time }
          localStorage.setItem('supplier_mock_data', JSON.stringify(suppliers))
          resolve({ code: 200, msg: '更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },
  
  // 删除供货商（软删除）
  deleteSupplier(id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let suppliers = localStorage.getItem('supplier_mock_data')
        suppliers = suppliers ? JSON.parse(suppliers) : []
        const index = suppliers.findIndex(s => s.id === id)
        if (index !== -1) {
          suppliers[index].is_del = 1
          localStorage.setItem('supplier_mock_data', JSON.stringify(suppliers))
          resolve({ code: 200, msg: '删除成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },
  
  // 更新状态
  updateStatus(id, status) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let suppliers = localStorage.getItem('supplier_mock_data')
        suppliers = suppliers ? JSON.parse(suppliers) : []
        const index = suppliers.findIndex(s => s.id === id)
        if (index !== -1) {
          suppliers[index].status = status
          localStorage.setItem('supplier_mock_data', JSON.stringify(suppliers))
          resolve({ code: 200, msg: '状态更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  }
}

export default {
  name: "supplierList",
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  data() {
    // 自定义联系电话校验
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value) && !/^\d{3,4}-?\d{7,8}$/.test(value)) {
        callback(new Error('请输入正确的手机号或固定电话'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoading: false,
      searchForm: {
        name: "",
        contact_name: "",
        contact_tel: "",
        status: null
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      activeCount: 0,
      inactiveCount: 0,
      sortField: '',
      sortOrder: '',
      
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        name: '',
        contact_name: '',
        contact_tel: '',
        address: '',
        remark: '',
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入供货商名称', trigger: 'blur' }],
        contact_tel: [{ validator: validatePhone, trigger: 'blur' }]
      },
      
      detailVisible: false,
      detailData: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        const params = {
          company_id: sessionStorage.getItem('company_id') || 1,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        }
        // 实际使用时替换为真实接口调用
        const res = await mockApi.getSupplierList(params)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          // 计算统计数量
          const allRes = await mockApi.getSupplierList({ company_id: params.company_id, pageNum: 1, pageSize: 999 })
          if (allRes.code === 200) {
            this.activeCount = allRes.data.filter(item => item.status === 1).length
            this.inactiveCount = allRes.data.filter(item => item.status === 0).length
          }
        } else {
          this.$message.error(res.msg || '数据加载失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    searchSubmit() {
      this.pageNum = 1
      this.getList()
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        name: "",
        contact_name: "",
        contact_tel: "",
        status: null
      }
      this.pageNum = 1
      this.getList()
    },
    
    // 分页大小变化
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.getList()
    },
    
    // 当前页变化
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.getList()
    },
    
    // 排序变化
    handleSortChange({ prop, order }) {
      if (prop === 'add_time') {
        this.sortField = 'add_time'
        this.sortOrder = order
        this.getList()
      }
    },
    
    // 新增
    addData() {
      this.dialogTitle = "新增供货商"
      this.form = {
        id: null,
        name: '',
        contact_name: '',
        contact_tel: '',
        address: '',
        remark: '',
        status: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    
    // 编辑
    goEdit(row) {
      this.dialogTitle = "编辑供货商"
      this.form = {
        id: row.id,
        name: row.name,
        contact_name: row.contact_name,
        contact_tel: row.contact_tel,
        address: row.address,
        remark: row.remark,
        status: row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    
    // 查看详情
    goDetail(row) {
      this.detailData = { ...row }
      this.detailVisible = true
    },
    
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        
        this.submitLoading = true
        try {
          const company_id = sessionStorage.getItem('company_id') || 1
          const submitData = {
            ...this.form,
            company_id: company_id
          }
          
          let res
          if (this.form.id) {
            // 编辑
            res = await mockApi.updateSupplier(submitData)
          } else {
            // 新增
            res = await mockApi.addSupplier(submitData)
          }
          
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('操作异常')
        } finally {
          this.submitLoading = false
        }
      })
    },
    
    // 弹窗关闭回调
    handleDialogClosed() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除供货商"${row.name}"吗？删除后数据不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'alipay-message-box'
      }).then(async () => {
        try {
          const res = await mockApi.deleteSupplier(row.id)
          if (res.code === 200) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.pageNum > 1) {
              this.pageNum--
            }
            this.getList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('删除异常')
        }
      }).catch(() => {})
    },
    
    // 处理更多菜单命令
    async handleCommand(command, row) {
      switch (command) {
        case 'detail':
          this.goDetail(row)
          break
        case 'disable':
          await this.changeStatus(row, 0)
          break
        case 'enable':
          await this.changeStatus(row, 1)
          break
      }
    },
    
    // 修改状态
    async changeStatus(row, status) {
      const action = status === 1 ? '启用' : '停用'
      this.$confirm(`确定要${action}供货商"${row.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'alipay-message-box'
      }).then(async () => {
        try {
          const res = await mockApi.updateStatus(row.id, status)
          if (res.code === 200) {
            this.$message.success(`${action}成功`)
            this.getList()
          } else {
            this.$message.error(res.msg || `${action}失败`)
          }
        } catch (error) {
          console.error(error)
          this.$message.error(`${action}异常`)
        }
      }).catch(() => {})
    },
    
    // 导出
    handleExport() {
      this.$message.info('导出功能开发中，实际可调用后端导出接口')
    },
    
    // 表格行斑马纹样式
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.supplier-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部样式 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .header-left {
    .el-breadcrumb {
      margin-bottom: 12px;

      ::v-deep .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: $text-secondary;
          font-size: 13px;

          &.is-link {
            color: $primary-color;

            &:hover {
              color: lighten($primary-color, 10%);
            }
          }
        }
        
        &:last-child .el-breadcrumb__inner {
          color: $text-primary;
          font-weight: 500;
        }
      }
    }

    .title-wrapper {
      display: flex;
      align-items: baseline;
      gap: 12px;
    }

    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: $text-primary;
      letter-spacing: -0.3px;
    }

    .badge-count {
      display: inline-block;
      padding: 2px 10px;
      background: rgba($primary-color, 0.1);
      color: $primary-color;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
    }
  }


   
  }


/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;

  .stat-card {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: $card-shadow;
    transition: all 0.2s ease;
    border: 1px solid transparent;

    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba($primary-color, 0.1);
    }

    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;

      &.icon-total {
        background: rgba($primary-color, 0.1);
        color: $primary-color;
      }
      &.icon-active {
        background: rgba($success-color, 0.1);
        color: $success-color;
      }
      &.icon-inactive {
        background: rgba($danger-color, 0.1);
        color: $danger-color;
      }
    }

    .stat-info {
      flex: 1;
      
      .stat-label {
        font-size: 13px;
        color: $text-secondary;
        margin-bottom: 4px;
      }
      
      .stat-number {
        font-size: 28px;
        font-weight: 600;
        color: $text-primary;
        line-height: 1.2;
      }
    }
  }
}

/* 筛选卡片样式 */
.filter-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  
  ::v-deep .el-card__body {
    padding: 20px 24px;
  }

  .filter-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;

    .filter-icon {
      color: $primary-color;
      font-size: 18px;
      margin-right: 8px;
    }

    .filter-title {
      font-size: 15px;
      font-weight: 600;
      color: $text-primary;
    }
  }

  .filter-form {
    .filter-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-end;
    }

    ::v-deep .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        font-weight: 500;
        color: $text-regular;
        font-size: 13px;
      }
      
      .el-input__inner, .el-select .el-input__inner {
        border-radius: 8px;
        border-color: $border-color;
        transition: all 0.2s;
        
        &:focus {
          border-color: $primary-color;
          box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
        }
      }
    }

    .action-buttons {
      margin-left: auto;
      
      .search-btn {
        background: $primary-color;
        border: none;
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;
        
        &:hover {
          background: lighten($primary-color, 8%);
        }
      }

      .reset-btn {
        border-radius: 20px;
        padding: 8px 20px;
        border-color: $border-color;
        color: $text-regular;
        
        &:hover {
          border-color: $primary-color;
          color: $primary-color;
        }
      }

       .add-btn {
      background: $primary-color;
      border: none;
      border-radius: 20px;
      padding: 8px 20px;
      font-weight: 500;
      box-shadow: 0 2px 4px rgba(22, 119, 255, 0.2);
      transition: all 0.2s ease;

      &:hover {
        background: lighten($primary-color, 8%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
      }
      }
    }
  }
}

/* 表格卡片样式 */
.table-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  
  ::v-deep .el-card__body {
    padding: 20px 24px;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid $border-color;

    .table-header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .table-icon {
        color: $primary-color;
        font-size: 18px;
      }

      .table-title {
        font-size: 16px;
        font-weight: 600;
        color: $text-primary;
      }
      
      ::v-deep .el-tag {
        background: $bg-gray;
        border: none;
        color: $text-secondary;
      }
    }

    .table-header-right {
      .el-button {
        color: $text-secondary;
        transition: all 0.2s;
        
        &:hover {
          color: $primary-color;
          background: rgba($primary-color, 0.05);
        }
      }
    }
  }
}

/* 表格样式优化 */
::v-deep .el-table {
  font-size: 13px;
  border-radius: 12px;
  overflow: hidden;

  th {
    background: $bg-gray !important;
    color: $text-secondary;
    font-weight: 500;
    font-size: 13px;
    padding: 12px 0;
    border-bottom: 1px solid $border-color;
  }

  td {
    padding: 14px 0;
    border-bottom: 1px solid $border-color;
  }

  .even-row {
    background: #ffffff;
  }

  .odd-row {
    background: #fbfbfc;
  }

  .hover-row > td {
    background: rgba($primary-color, 0.02) !important;
  }
  
  .el-table__sort-icon {
    color: $text-secondary;
    
    &.ascending, &.descending {
      color: $primary-color;
    }
  }
}

/* 单元格内容样式 */
.supplier-info {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: $primary-color;
    font-size: 16px;
  }
  
  .name-text {
    font-weight: 500;
    color: $text-primary;
  }
}

.contact-info, .contact-phone, .address-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    color: $text-secondary;
    font-size: 13px;
  }
  
  span {
    color: $text-regular;
  }
}

.remark-text {
  color: $text-secondary;
  font-size: 12px;
}

.time-text {
  color: $text-secondary;
  font-size: 12px;
}

.index-badge {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: $bg-gray;
  color: $text-secondary;
  border-radius: 13px;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .edit-btn {
    color: $primary-color;
    padding: 4px 8px;
    
    &:hover {
      background: rgba($primary-color, 0.08);
    }
  }
  
  .delete-btn {
    color: $danger-color;
    padding: 4px 8px;
    
    &:hover {
      background: rgba($danger-color, 0.08);
    }
  }

  .more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    cursor: pointer;
    color: $text-secondary;
    transition: all 0.2s;
    
    &:hover {
      background: rgba($text-secondary, 0.1);
      color: $primary-color;
    }
    
    i {
      font-size: 16px;
    }
  }
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 16px;
  border-top: 1px solid $border-color;

  ::v-deep .el-pagination {
    .el-pagination__total, .el-pagination__jump {
      color: $text-secondary;
      font-size: 13px;
    }

    .btn-prev, .btn-next, .el-pager li {
      border-radius: 8px;
      margin: 0 4px;
      font-weight: 500;
      transition: all 0.2s;
      
      &:hover {
        color: $primary-color;
      }
    }

    .el-pager li.active {
      background: $primary-color;
      color: white;
      
      &:hover {
        background: lighten($primary-color, 8%);
      }
    }
    
    .el-select .el-input__inner {
      border-radius: 8px;
    }
  }
}

/* 弹窗样式 - 支付宝风格 */
::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 35px -8px rgba(0, 0, 0, 0.2);
    
    .el-dialog__header {
      border-bottom: 1px solid $border-color;
      padding: 20px 24px;
      background: white;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: $text-primary;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
    }
    
    .el-dialog__footer {
      border-top: 1px solid $border-color;
      padding: 16px 24px;
    }
  }
  
  .el-form-item__label {
    font-weight: 500;
    color: $text-regular;
  }
  
  .el-input__inner, .el-textarea__inner {
    border-radius: 8px;
    border-color: $border-color;
    
    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
    }
  }
  
  .el-radio__input.is-checked .el-radio__inner {
    background: $primary-color;
    border-color: $primary-color;
  }
  
  .el-descriptions {
    .el-descriptions__label {
      background: $bg-gray;
      color: $text-regular;
      font-weight: 500;
      width: 100px;
    }
    
    .el-descriptions__content {
      color: $text-primary;
    }
  }
}

/* 消息框支付宝风格 */
::v-deep .alipay-message-box {
  border-radius: 16px;
  
  .el-message-box__header {
    padding-top: 20px;
    .el-message-box__title {
      font-weight: 600;
    }
  }
  
  .el-message-box__btns button {
    border-radius: 20px;
    padding: 8px 20px;
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .stats-row {
    flex-direction: column;
    gap: 12px;
    
    .stat-card {
      padding: 16px 20px;
    }
  }
  
  .filter-form .filter-row {
    flex-direction: column;
    align-items: stretch;
    
    .el-form-item {
      width: 100%;
    }
    
    .action-buttons {
      margin-left: 0;
      display: flex;
      gap: 12px;
      
      .el-button {
        flex: 1;
        text-align: center;
      }
    }
  }
}

@media (max-width: 768px) {
  .supplier-container {
    padding: 16px;
  }
  
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    .header-right {
      width: 100%;
      
      .add-btn {
        width: 100%;
        justify-content: center;
      }
    }
  }
  
  .table-card ::v-deep .el-card__body {
    padding: 16px;
  }
  
  .action-buttons {
    flex-wrap: wrap;
  }
}
</style>